import { togglePageScroll } from '@/utils/general'
const OSvg = () => import('@/components/OSvg')

export default ({ modalName = 'modal' }) => {
  return {
    components: {
      OSvg
    },
    props: {
      classes: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      modalName () {
        return modalName
      },
      modalProps () {
        return {
          name: modalName,
          classes: [modalName, ...this.classes],
          height: 'auto',
          adaptive: true
        }
      }
    },
    methods: {
      onModalClose () {
        this.$emit('closed')
        togglePageScroll(false)
      },
      toggleActivation (open = true) {
        this.$modal[open ? 'show' : 'hide'](modalName)
        togglePageScroll(open)
      }
    }
  }
}
